import { compareDesc, parseISO } from 'date-fns';

import { IArchivedMedicaidPlan } from '~/services/api/medicaidPlan/types';

const sortNewestFirst = (history: IArchivedMedicaidPlan[]): IArchivedMedicaidPlan[] =>
  [...history].sort((a, b) => compareDesc(parseISO(a.archivedOn), parseISO(b.archivedOn)));

export default sortNewestFirst;
